import { render } from "./ActivateTenant.vue?vue&type=template&id=36e24222&scoped=true&ts=true"
import script from "./ActivateTenant.vue?vue&type=script&lang=ts"
export * from "./ActivateTenant.vue?vue&type=script&lang=ts"

import "./ActivateTenant.vue?vue&type=style&index=0&id=36e24222&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e24222"]])

export default __exports__